import React from 'react';
import data from '../../data/team';
function Team() {
  return (
    <section className="team section-padding pt-0">
      <div className="container">
        <div className="sec-head mb-80">
          <div className="d-flex align-items-center">
            <div>
              <span className="sub-title main-color mb-5">My Latest Work</span>
              <h3 className="fw-600 fz-50 text-u d-rotate wow">
                <span className="rotate-text">
                 Latest<span className="fw-200">Works</span>
                </span>
              </h3>
            </div>
            <div className="ml-auto vi-more">
              <a href="/home-modern-studio" className="butn butn-sm butn-bord radius-30">
                <span>Check More</span>
              </a>
              <span className="icon ti-arrow-top-right"></span>
            </div>
          </div>
        </div>
        <div className="row">
          {data.map((item, i) => (
            <div key={i} className="col-lg-4">
              <div className="item md-mb50">
                <div className="img">
                  <img src={item.img} alt="" />
                  <div className="info">
                    <span className="fz-12">{item.subName}</span>
                    <h6 className="fz-18">{item.name}</h6>
                  </div>
                </div>
                <div className="social">
                  <div className="links">
                    {/* <a href="#0">
                      <i className="fab fa-facebook-f"></i>
                    </a> */}
                    <a href="#0">
                      <i className="fab fa-behance"></i>
                    </a>
                    {/* <a href="#0">
                      <i className="fab fa-instagram"></i>
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Team;
